import { Col, Form, Modal, Row } from "react-bootstrap";
import { Actions, onKeyDownForm } from "../../utils";
import DefaultButton from "../widgets/default-button";
import "../../assets/scss/components/modal.scss";
import { useEffect, useState } from "react";
import { getCountryList } from "../../actions/user";

export const PublisherModal: React.FC<any> = (props) => {
    const [countryList, setCountryList] = useState<any[]>([]);
    const { show, model, setModel, closeModal, saveModal, mkey = "" } = props;

    useEffect(() => {
        getCountryList({})
            .then((res: any) => {
                setCountryList(res?.countries || []);
            })
            .catch((error: any) => {
                console.error("Error fetching country list:", error);
            });
    }, []);

    return (<>
        <Modal
            show={show}
            key={"modal_" + mkey}
            size="lg" //'sm' | 'lg' | 'xl'
            backdrop="static"
            onHide={closeModal}
            centered
            className="custom-modal member-modal"
        >
            <Form noValidate
                className="custom-form"
                onSubmit={saveModal}
                onKeyDown={onKeyDownForm}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {" "}
                        {model.action === Actions.add ? "New" : "Edit"} Publisher
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Form.Group as={Col} md={6} controlId="title">
                            <Form.Label>Title<span className="required">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="title"
                                value={model.title}
                                onChange={(e) =>
                                    setModel({ ...model, title: e.target.value })
                                }
                                isInvalid={!model.validate && model.title === ""}
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Name can not empty.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md={6} controlId="dba">
                            <Form.Label>Doing Business As</Form.Label>
                            <Form.Control
                                type="text"
                                name="dba"
                                value={model.dba || ""}
                                onChange={(e) =>
                                    setModel({ ...model, dba: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} controlId="parent_id">
                            <Form.Label>Parent ID</Form.Label>
                            <Form.Control
                                type="number"
                                name="parent_id"
                                value={model.parent_id || ""}
                                onChange={(e) =>
                                    setModel({ ...model, parent_id: e.target.value })
                                }
                                disabled={true}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md={6} controlId="level">
                            <Form.Label>Level</Form.Label>
                            <Form.Control
                                type="number"
                                name="level"
                                value={model.level || 2}
                                onChange={(e) =>
                                    setModel({ ...model, level: e.target.value })
                                }
                                disabled={true}
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} controlId="country_id">
                            <Form.Label>Country</Form.Label>
                            <Form.Select
                                name="country_id"
                                value={model.country_id || ""}
                                onChange={(e) =>
                                    setModel({ ...model, country_id: e.target.value })
                                }
                            >
                                <option value="">Select Country</option>
                                {countryList.map((country) => (
                                    <option key={country.id} value={country.id}>
                                        {country.title}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} md={6} controlId="state">
                            <Form.Label>State</Form.Label>
                            <Form.Control
                                type="text"
                                name="state"
                                value={model.state || ""}
                                onChange={(e) =>
                                    setModel({ ...model, state: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} controlId="city">
                            <Form.Label>City</Form.Label>
                            <Form.Control
                                type="text"
                                name="city"
                                value={model.city || ""}
                                onChange={(e) =>
                                    setModel({ ...model, city: e.target.value })
                                }
                            />
                        </Form.Group>
                        <Form.Group as={Col} md={6} controlId="addr">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                                type="text"
                                name="addr"
                                value={model.addr || ""}
                                onChange={(e) =>
                                    setModel({ ...model, addr: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} controlId="url">
                            <Form.Label>URL</Form.Label>
                            <Form.Control
                                type="text"
                                name="url"
                                value={model.url || ""}
                                onChange={(e) =>
                                    setModel({ ...model, url: e.target.value })
                                }
                            />
                        </Form.Group>
                        <Form.Group as={Col} md={6} controlId="zip_code">
                            <Form.Label>ZIP Code</Form.Label>
                            <Form.Control
                                type="text"
                                name="zip_code"
                                value={model.zip_code || ""}
                                onChange={(e) =>
                                    setModel({ ...model, zip_code: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} controlId="tel">
                            <Form.Label>Telephone</Form.Label>
                            <Form.Control
                                type="text"
                                name="tel"
                                value={model.tel || ""}
                                onChange={(e) =>
                                    setModel({ ...model, tel: e.target.value })
                                }
                            />
                        </Form.Group>
                        <Form.Group as={Col} md={6} controlId="fax">
                            <Form.Label>Fax</Form.Label>
                            <Form.Control
                                type="text"
                                name="fax"
                                value={model.fax || ""}
                                onChange={(e) =>
                                    setModel({ ...model, fax: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} controlId="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="email"
                                value={model.email || ""}
                                onChange={(e) =>
                                    setModel({ ...model, email: e.target.value })
                                }
                            />
                        </Form.Group>
                        <Form.Group as={Col} md={6} controlId="register_from">
                            <Form.Label>Register From</Form.Label>
                            <Form.Control
                                type="text"
                                name="register_from"
                                value={model.register_from || ""}
                                onChange={(e) =>
                                    setModel({ ...model, register_from: e.target.value })
                                }
                                disabled={true}
                            />
                        </Form.Group>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <DefaultButton
                        className="small-button"
                        textColor="var(--color-primary)"
                        color="white"
                        borderColor="var(--color-primary)"
                        onClick={closeModal}
                    >
                        Close
                    </DefaultButton>
                    <DefaultButton
                        type="submit"
                        className="small-button"
                        color="var(--color-primary)"
                        textColor="white"
                        disabled={model.message !== ""}
                    >
                        Save
                    </DefaultButton>
                </Modal.Footer>
            </Form>
        </Modal>
    </>);
};